module.exports = __webpack_public_path__ + "img/home_top.4fd88f15.jpg";